export enum CDFWorkflowStatus {
  DRAFT = "Draft",
  SENT_FOR_APPROVAL = "Sent for Approval",
  APPROVED = "Approved",
  REJECTED = "Rejected"
}
